import classes from "./Button.module.css";

function Button({
  type,
  disabled,
  className,
  onClick,
  children,
  style,
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`${classes.button} ${className ? className : ""}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default Button;
